import React from 'react';

import { salesOrdersContainerConfiguration } from '@totem/components/salesOrders/list/containerConfiguration';
import SalesOrdersContainer from '@totem/components/salesOrders/list/SalesOrdersContainer';
import SalesOrdersLayout from '@totem/components/salesOrders/list/SalesOrdersLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

type Props = {
  buildingId: string;
};

// Sales order lines that still need cancelling in NetSuite when a building is decommissioned.
const OpenBuildingSalesOrderLines = ({ buildingId }: Props) => {
  return (
    <InputContainer
      filterConfig={salesOrdersContainerConfiguration}
      staticFilters={[
        { field: 'building.id', values: [buildingId] },
        { field: 'status', values: ['Active', 'Pending', 'Pending Dates'] },
      ]}
      defaultSort={{ field: 'nsSalesOrder.tranId', direction: 'ascend' }}
    >
      <SalesOrdersContainer>
        <SalesOrdersLayout />
      </SalesOrdersContainer>
    </InputContainer>
  );
};

export default OpenBuildingSalesOrderLines;
